// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	//apiUrl: 'https://api.epimsabt.com/api/',
	apiUrl: 'http://localhost:3333/api/',
	//apiUrl: 'http://193.189.14.43:3333/api/',
	//apiUrl: 'http://161.158.210.183:3333/api/'
	// apiUrl: 'http://161.158.207.69:3333/api/',

	//apiUrl: 'http://phc-s-04151.africa-me.shell.com:4444/api/',

};



//apiUrl: 'https://api.epimsabt.com/api/'

//apiUrl: 'http://localhost:3333/api/'
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
